import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=39c2f908&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c2f908"]])

export default __exports__